import React,{useState, useEffect} from "react";
import QuizView from "./Views/QuizView";
import { observer } from "mobx-react-lite";

const QuizPresenter = observer(({model}) => { 
    const [quizData, setQuizData] = useState(null);
    const [currIndex, setCurrIndex] = useState(0);
    const [points, setPoints] = useState(0);

    useEffect(() => {generateQuiz()}, []);

    function generateQuestions(paintings){

        paintings.sort((a,b) => a.date - b.date);

        const correctPainting = paintings[0];
        const options = paintings.map(painting => ({
            text: painting.title,
            image: painting.image,
            correct: painting === correctPainting,
        })).sort(() => Math.random() - 0.5);

        return ([{
            question: "Which of these paintings is the oldest?",
            options: options
        }]);
    }

   function handleAnswer(option){
    if(option.correct){setPoints(points + 1);}

    if(currIndex + 1 < quizData.length){setCurrIndex(currIndex + 1);}

    else{
        alert("Congratulations on completing the quiz! Your score is: " + (points + (option.correct ? 1 : 0) ) + " out of " + quizData.length);
        restartQuiz();
    }
   }

   function restartQuiz(){
    setPoints(0);
    setCurrIndex(0);
    generateQuiz();
   }

   async function generateQuiz() {
    try {
        const paintings = await model.getRandomPaintings(21);

        const questions = [];
        for (let i = 0; i < 7; i++) {
            const startIndex = i * 3;
            const selectedPaintings = paintings.slice(startIndex, startIndex + 3);
            const question = generateQuestions(selectedPaintings);
            questions.push(...question);
        }

        setQuizData(questions);
        } catch (error) {
            console.error("Failed to generate quiz:", error);
        }
    }

    return (
        <>
          <QuizView quizData = {quizData ? quizData[currIndex] : null}  
                    onAnswer = {handleAnswer}
                    onRestart = {restartQuiz}/>
        </>
      );
    

});

export default QuizPresenter;
